const getSongNumberText = (number) => 1 < number && `${number}曲`

export default getSongNumberText
